export default [
  {
    title   : "Lösung gefunden",
    date    : "10.10.2019 10:00:00",
    avatar  : "https://randomuser.me/api/portraits/men/1.jpg",
    text    : "Wir haben eine Lösung gefunden für die Reparaturen der DJI Artikel. Der Transfert bis zum DJI Service Center geht ab sofort via und in Zusammenarbeit mit der Fa. Ingram Micro. Freundliche Grüsse. Bernard Burgy"
  },
  {
    title   : 'Fitbit Reparaturservice',
    date    : "10.10.2019 10:00:00",
    avatar  : "https://randomuser.me/api/portraits/men/1.jpg",
    text    :"Fitbit Reparaturservice Bei Einsendung zur Reparatur von Artikeln der Marke Fitbit muss das dazugehörende Ladekabel zwingend beigelegt sein. Im Garantiefall, wenn das Kabel nicht mitgeliefert ist, wird die Gutschrift um den Wert dieses Zubehörs reduziert.Freundliche Grüsse Bernard Burgy"
  },

]
